define([
    'lodash',
    'fast-json-stable-stringify'
], function (_, stringify) {
    'use strict';

    return {
        encode: value => _.flow([stringify, encodeURIComponent, unescape, btoa])(value),
        decode: value => _.flow([atob, escape, decodeURIComponent, JSON.parse])(value)
    };
});
